import { Link } from 'react-router-dom';
import { siteConfig } from '@/data/mock';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const FACEBOOK_URL = 'https://www.facebook.com/share/1KHcXM4ydD/';
const INSTAGRAM_URL = 'https://www.instagram.com/elevateminnesota?igsh=dDU5anh2dWI3MmY1';

const FacebookIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const InstagramIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

export const SocialLinks = ({ className = '', iconSize = 'w-5 h-5' }) => (
  <div className={`flex items-center gap-4 ${className}`} data-testid="social-links">
    <a
      href={FACEBOOK_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-400 hover:text-brand-gold transition-colors"
      aria-label="Facebook"
      data-testid="social-facebook"
    >
      <FacebookIcon className={iconSize} />
    </a>
    <a
      href={INSTAGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-400 hover:text-brand-gold transition-colors"
      aria-label="Instagram"
      data-testid="social-instagram"
    >
      <InstagramIcon className={iconSize} />
    </a>
  </div>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-dark">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-3">
          {/* Logo, Description & Social */}
          <div>
            <img
              src="/images/site/footer_logo.png"
              alt="ElevateMN"
              className="h-10 w-auto mb-6"
            />
            <p className="text-gray-400 text-sm leading-relaxed max-w-sm mb-6">
              {siteConfig.description}
            </p>
            <SocialLinks />
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-white font-semibold mb-6">Navigation</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 text-sm hover:text-brand-gold transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-gray-400 text-sm hover:text-brand-gold transition-colors">
                  Events
                </Link>
              </li>
              <li>
                <Link to="/calendar" className="text-gray-400 text-sm hover:text-brand-gold transition-colors">
                  Calendar
                </Link>
              </li>
              <li>
                <Link to="/programs" className="text-gray-400 text-sm hover:text-brand-gold transition-colors">
                  Programs
                </Link>
              </li>
              <li>
                <Link to="/newsletter" className="text-gray-400 text-sm hover:text-brand-gold transition-colors">
                  Newsletter
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 text-sm hover:text-brand-gold transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 text-sm hover:text-brand-gold transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-6">Contact</h3>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li>{siteConfig.contact.email}</li>
              <li>{siteConfig.contact.phone}</li>
              <li>{siteConfig.contact.address}</li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-gray-800 flex items-center justify-between">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} ElevateMN. All rights reserved.
          </p>
          <Link to="/file-room/login" className="text-gray-600 text-xs hover:text-gray-400 transition-colors">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
